import React from 'react';
import { FaFacebookF, FaInstagram,  FaTwitter,} from 'react-icons/fa';

function SocialWidget() {
    return (
        <>
            <a href="/">
                <FaFacebookF />
            </a>
            <a href="/">
                <FaTwitter />
            </a>
            <a href="/">
                <FaInstagram />
            </a>
        </>
    );
}

export default SocialWidget;
